import axios from 'axios';
import type { HeadersDefaults } from 'axios';
import $ from 'jquery';
import { decamelizeKeys } from 'humps';
import _ from 'lodash';

const client = axios.create();
client.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
const methods: (keyof HeadersDefaults)[] = ['post', 'put', 'patch', 'delete'];
methods.forEach((method) => {
  const token = $('meta[name="csrf-token"]').attr('content');
  if (token == null) {
    return;
  }
  const headers = client.defaults.headers[method]!;
  headers['X-CSRF-TOKEN'] = token;
});

client.interceptors.request.use(
  ({ data, ...config }) => ({
    ...config,
    // NOTE: FormDataは変換しない
    data: _.isPlainObject(data) ? decamelizeKeys(data) : data,
  }),
  (error) => Promise.reject(error)
);

export default client;
